import React from "react";
import Seo from "./Seo";

const Imprint: React.FC = () => {
  return (
    <section className="imprint" id="imprint">
      <Seo
        lang="de"
        path="/impressum"
        title="Impressum – Thomas Grimmenstein"
        description="Impressum von Thomas Grimmenstein, selbstständiger Softwareentwickler."
        translated={false}
      />
      <h2 className="headings">Impressum</h2>
      <div className="imprint-content">
        <h1>Impressum</h1>

        <p>
          Thomas Grimmenstein <br />
          Vollersrodaer Str. 1<br />
          99428 Weimar-Legefeld
        </p>

        <h2>Kontakt</h2>
        <p>E-Mail: info@grimmenstein.dev</p>
        <p>
          Alternativ kannst du auch mein{" "}
          <a href="/contact">Kontaktformular</a> nutzen.
        </p>

        <p>
          Quelle: <a href="https://www.e-recht24.de">eRecht24</a>
        </p>
      </div>
    </section>
  );
};

export default Imprint;
